import React from 'react';
import { SpecialistCard } from '../../../../../components/SpecialistCard';
import { Resource } from '../../../../../models/Schedule';
import { SlotHour } from '../../../../../modules/slots';
import { handleSpecialtiesWithExpertises } from '../../../../../utils/specialist-utils';

type ProfessionalCardProps = {
  resourceSlot?: SlotHour;
  productName: string;
};

const ProfessionalCard: React.FC<ProfessionalCardProps> = ({ resourceSlot, productName }) => {
  return (
    <SpecialistCard
      imgSrc={`https://aps-digital.s3.amazonaws.com/profissionais/${resourceSlot?.resourceId}.jpg`}
      title={resourceSlot?.resource || ''}
      description={productName}
    />
  );
};

export default ProfessionalCard;
